import React, { useRef, useState } from "react";

import { Select as AntSelect } from "antd";

import { parseInputRules } from "utils";

import { Form, Icon, InputLabel, Spin } from "components";

const getSuffixIcon = (showArrow, hasBeenFocused, showSearch, mode) => {
  if (showArrow) return <Icon iconName="tabler/chevron-down" size="s" />;
  if (hasBeenFocused) {
    if (showSearch || mode === "tags" || mode === "multiple") {
      return <Icon iconName="tabler/search" size="s" />;
    }
    return <Icon iconName="tabler/chevron-up" size="s" />;
  }
  return <Icon iconName="tabler/chevron-down" size="s" />;
};

export const { Option } = AntSelect;
export const { OptGroup } = AntSelect;

export const Select = ({
  allowClear = false,
  children,
  defaultActiveFirstOption,
  defaultValue,
  disabled,
  popupMatchSelectWidth,
  dropdownStyle,
  filterOption,
  initialValue,
  label,
  tooltip,
  message,
  mode,
  name,
  optionFilterProp,
  rules,
  showArrow,
  showSearch,
  style,
  value,
  optionLabelProp = "children",
  onSearch,
  dataTestId,
  onBlur = () => {},
  onChange = (value) => {}, // eslint-disable-line
  onClick = (_e) => {},
  className = "",
  labelClassName = "",
  isLoading,
  help,
}) => {
  const inputElement = useRef(null);
  const [hasBeenFocused, setHasBeenFocused] = useState(false);
  const [internalValue, setInternalValue] = useState(initialValue);

  const handleBlur = (...args) => {
    setHasBeenFocused(false);
    onBlur(...args);
  };

  const handleChange = (...args) => {
    setInternalValue(args[0]);
    onChange(...args);
    setTimeout(() => {
      inputElement?.current?.blur();
    }, 1);
  };

  const handleLabelClick = (e) => {
    setHasBeenFocused(true);
    inputElement.current.focus();
    onClick(e);
  };

  const active = !!(
    hasBeenFocused ||
    internalValue ||
    internalValue === false ||
    (value !== null && value !== undefined) ||
    (internalValue !== null && internalValue !== undefined)
  );

  const required = rules && rules[0] && rules[0].required;

  return (
    <Form.Item
      onClick={handleLabelClick}
      className={`floating-select floating-input ${disabled ? "disabled" : "message"} ${hasBeenFocused ? "active" : ""} ${className}`}
      colon={false}
      label={<InputLabel active={active} required={required} label={label} className={labelClassName} tooltip={tooltip} />}
      name={name}
      rules={parseInputRules(rules, message)}
      initialValue={initialValue}
      help={help}
    >
      <AntSelect
        data-testid={dataTestId}
        allowClear={allowClear}
        defaultActiveFirstOption={defaultActiveFirstOption}
        defaultValue={defaultValue}
        disabled={disabled}
        popupMatchSelectWidth={popupMatchSelectWidth}
        filterOption={filterOption}
        menuItemSelectedIcon={<Icon iconName="tabler/circle-check" />}
        mode={mode}
        optionFilterProp={optionFilterProp}
        ref={inputElement}
        showAction={["focus"]}
        showSearch={showSearch}
        style={style}
        value={value}
        onSearch={onSearch}
        onBlur={handleBlur}
        onChange={handleChange}
        onClick={() => setHasBeenFocused(true)}
        optionLabelProp={optionLabelProp}
        notFoundContent={
          <span
            style={{
              textAlign: "center",
              width: "100%",
              display: "inline-block",
            }}
          >
            {isLoading ? <Spin size="small" /> : <Icon iconName="tabler/ban" />}
          </span>
        }
        suffixIcon={getSuffixIcon(showArrow, hasBeenFocused, showSearch, mode)}
        styles={{ popup: { root: dropdownStyle } }}
      >
        {children}
      </AntSelect>
    </Form.Item>
  );
};
